(() => {
  const money = (cents) =>
    '€' + (cents / 100).toFixed(2).replace('.', ',');

  const init = (root) => {
    if (root.dataset.gsBound === 'true') return;
    root.dataset.gsBound = 'true';

    let variants;
    let productVariants = [];
    try {
      variants = JSON.parse(root.dataset.variants);
    } catch (e) {
      return;
    }
    try {
      productVariants = JSON.parse(root.dataset.productVariants);
    } catch (e) {
      productVariants = [];
    }

    const pdpIndex = Number(root.dataset.pdpOptionIndex || 0);
    const matchIndex = Number(root.dataset.matchOptionIndex || 0);
    const askIndex = Number(root.dataset.askOptionIndex || 1);

    const ask = root.querySelector('[data-gs-ask]');
    const form = root.querySelector('[data-gs-form]');
    const idInput = root.querySelector('[data-gs-variant-id]');
    const submit = root.querySelector('[data-gs-submit]');
    const submitText = root.querySelector('[data-gs-submit-text]');
    const setPrice = root.querySelector('[data-gs-set-price]');
    const soloPrice = root.querySelector('[data-gs-solo-price]');
    const fromLabel = root.dataset.gsFromLabel || '__PRICE__';
    const from = (cents) => fromLabel.replace('__PRICE__', money(cents));
    const setWas = root.querySelector('[data-gs-set-was]');
    const saving = root.querySelector('[data-gs-saving]');
    const matchSelect = root.querySelector('[data-gs-match-select]');
    const askSelect = root.querySelector('[data-gs-ask-select]');
    const options = Array.from(root.querySelectorAll('.gs-bundle__option'));

    const addToCart = document.querySelector('.product--product-form');
    const initialSubmitText = submitText.textContent;

    let mode = 'solo';
    let askValue = null;
    let syncing = false;

    const pdpRadios = () =>
      Array.from(
        document.querySelectorAll(
          '.variations .product-form__input--block input[type="radio"]'
        )
      );

    const pdpSize = () => {
      const checked = pdpRadios().find((r) => r.checked);
      return checked ? checked.value : null;
    };

    const setPdpSize = (value) => {
      const target = pdpRadios().find((r) => r.value === value);
      if (!target || target.checked) return;
      syncing = true;
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    };

    const findVariant = () => {
      const size = pdpSize();
      if (!size || !askValue) return null;
      return variants.find(
        (v) => v.options[matchIndex] === size && v.options[askIndex] === askValue
      );
    };

    const cheapest = (list) =>
      list.reduce((low, v) => (low === null || v.price < low ? v.price : low), null);

    const bestSaving = (list) =>
      list.reduce((best, v) => {
        if (!v.compare_at_price || v.compare_at_price <= v.price) return best;
        const pct = Math.round(
          ((v.compare_at_price - v.price) / v.compare_at_price) * 100
        );
        return pct > best ? pct : best;
      }, 0);

    const showSaving = (pct) => {
      if (!saving) return;
      if (!pct || !root.dataset.gsSaveLabel) {
        saving.hidden = true;
        return;
      }
      saving.textContent = root.dataset.gsSaveLabel.replace('__PCT__', pct);
      saving.hidden = false;
    };


    const syncSelects = () => {
      const size = pdpSize();
      if (matchSelect) matchSelect.value = size || '';
      if (askSelect) askSelect.classList.toggle('is-empty', !askValue);
    };

    const renderPrices = () => {
      const size = pdpSize();

      if (soloPrice) {
        const match = size
          ? productVariants.find((v) => v.options[pdpIndex] === size)
          : null;
        const low = cheapest(productVariants);
        soloPrice.textContent = match ? money(match.price) : from(low);
      }

      if (!setPrice) return;

      const exact = findVariant();

      if (!exact) {
        const forSize = size
          ? variants.filter((v) => v.options[matchIndex] === size)
          : variants;
        const pool = forSize.length ? forSize : variants;
        setPrice.textContent = from(cheapest(pool));
        if (setWas) setWas.hidden = true;
        showSaving(bestSaving(pool));
        return;
      }

      setPrice.textContent = money(exact.price);

      if (exact.compare_at_price > exact.price) {
        if (setWas) {
          setWas.textContent = money(exact.compare_at_price);
          setWas.hidden = false;
        }
        showSaving(
          Math.round(
            ((exact.compare_at_price - exact.price) / exact.compare_at_price) * 100
          )
        );
      } else {
        if (setWas) setWas.hidden = true;
        showSaving(0);
      }
    };

    const render = () => {
      syncSelects();
      renderPrices();
      options.forEach((o) =>
        o.classList.toggle('is-selected', o.dataset.gsMode === mode)
      );

      const isSet = mode === 'set';
      ask.hidden = !isSet;
      form.hidden = !isSet;
      if (addToCart) addToCart.hidden = isSet;

      if (!isSet) return;

      const variant = findVariant();

      if (!variant) {
        idInput.value = '';
        submit.disabled = true;
        submitText.textContent = pdpSize()
          ? initialSubmitText
          : root.dataset.gsSizeFirst || initialSubmitText;
        return;
      }

      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submitText.textContent = root.dataset.gsAddLabel || 'Add to cart';
    };

    options.forEach((o) =>
      o.addEventListener('change', () => {
        mode = o.dataset.gsMode;
        render();
      })
    );

    if (matchSelect) {
      matchSelect.addEventListener('change', () => {
        if (matchSelect.value) setPdpSize(matchSelect.value);
        render();
      });
    }

    if (askSelect) {
      askSelect.addEventListener('change', () => {
        askValue = askSelect.value || null;
        render();
      });
    }

    document.addEventListener('change', (e) => {
      if (syncing) return;
      if (e.target.closest('.variations .product-form__input--block')) render();
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (submit.disabled) return;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then((r) => r.json())
        .then((data) => {
          const count = document.querySelector('.thb-item-count');
          if (count) count.textContent = data.item_count;
          document.documentElement.classList.add('js-ajax-cart-drawer-opened');
          if (typeof liquidAjaxCart !== 'undefined' && liquidAjaxCart.update) {
            liquidAjaxCart.update();
          }
        })
        .catch(() => {});
    });

    render();
  };

  const initAll = () =>
    document.querySelectorAll('[data-gs-bundle]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();